import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";
import CenterModal from "components/common/Modal/CenterModal";
import Button from "components/common/buttons/buttons";
import { useRouter } from "next/router";
import { CommnetComponentsType } from "types/main";

interface props {
  setModal: any;
  type: CommnetComponentsType;
  deleteHandler: any;
}
const CommentDeleteModal = ({ setModal, type, deleteHandler }: props) => {
  const modalRef = useModalClickOutside(setModal); // 모달 참조를 위한 ref 추가
  const router = useRouter();
  return (
    <CenterModal modalRef={modalRef} containerClass="gap-4">
      <span className={`${TYPO.TYPO5_SB} text-gray80`}>{`내 ${
        type === "comment" ? "댓글" : "의견"
      }을 삭제할까요?`}</span>
      <div className="justify-start items-start gap-2 inline-flex">
        <Button
          text={"닫기"}
          type="tertiary"
          size="xl"
          width="w-full"
          clickHandler={() => {
            setModal(false);
          }}
        />
        {/* <Button
          text={"삭제하기"}
          type="primary"
          size="xl"
          width="w-full"
          clickHandler={() => {
            setModal(false);
            deleteHandler();
          }}
        /> */}
        <button
          data-test-id="comment-delete-modal-delete-button"
          className="gap-1 flex justify-center items-center  bg-blue40 !text-white   h-[54px] px-[18px] py-[13px] rounded-[14px]  text-lg font-medium leading-7 w-full !cursor-pointer "
          onClick={(e: any) => {
            e.stopPropagation();
            setModal(false);
            deleteHandler();
          }}
        >
          <p>삭제하기</p>
        </button>
      </div>
    </CenterModal>
  );
};

export default CommentDeleteModal;
